
export default {
  name: 'ContentSwitcher',

  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },

    value: {
      type: [String, Number, Boolean],
      default: null
    },

    size: {
      type: String,
      default: 'md',
      validator: prop => ['sm', 'md'].includes(prop)
    },

    options: {
      type: Array,
      default: () => []
    },

    optionValueKey: {
      type: String,
      default: 'value'
    },

    optionLabelKey: {
      type: String,
      default: 'label'
    },

    optionDisabledKey: {
      type: String,
      default: 'disabled'
    },

    fullWidth: {
      type: Boolean,
      default: false
    },

    canSyncWithUrl: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    compOptions() {
      let options = []

      if (this.options.length) {
        // This allows you to pass a looser flat array from an API e.g ['Yes', 'No'] or [5, 9]
        if (typeof this.options[0] === 'string' || typeof this.options[0] === 'number') {
          options = this.options.map(option => {
            return {
              [this.optionLabelKey]: option,
              [this.optionValueKey]: option,
              disabled: this.optionDisabledKey
            }
          })
        } else {
          options = this.options
        }
      }

      // Filter out any options that have active: false
      return options.filter(option => !('active' in option) || option.active)
    },

    compValue: {
      get() {
        return this.value
      },

      set(tab) {
        if (this.canSyncWithUrl && this.$route.query.tab !== tab) {
          this.$router.replace({ query: { ...this.$route.query, tab } })
        }
      }
    }
  },

  watch: {
    '$route.query'(newQuery, oldQuery) {
      if (this.canSyncWithUrl && newQuery.tab !== oldQuery.tab) {
        this.compValue = newQuery.tab
        this.$emit('input', this.$route.query.tab)
      }
    }
  },

  created() {
    if (this.canSyncWithUrl && this.$route.query.tab) {
      this.compValue = this.$route.query.tab
      this.$emit('input', this.$route.query.tab)
    }
  },

  methods: {
    handleClick(value) {
      if (!this.isDisabled) {
        this.compValue = value

        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
}
